import { useStars } from '../lib/stars';

export function StarButton({ slug, size = 'md' }: { slug: string; size?: 'md' | 'lg' }) {
  const { stars, toggle } = useStars();
  const on = !!stars[slug];
  const dim = size === 'lg' ? 'h-11 w-11' : 'h-11 w-11';
  return (
    <button
      type="button"
      aria-pressed={on}
      aria-label={on ? 'Remove star' : 'Star this recipe'}
      title={on ? 'Starred' : 'Star this recipe'}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        toggle(slug);
      }}
      className={`inline-flex items-center justify-center rounded-full text-ink-soft transition-colors hover:bg-line/50 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ink ${dim}`}
    >
      <svg
        viewBox="0 0 24 24"
        className={size === 'lg' ? 'h-6 w-6' : 'h-5 w-5'}
        fill={on ? '#D9A400' : 'none'}
        stroke={on ? '#A87E00' : 'currentColor'}
        strokeWidth="1.7"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <path d="M12 2.8l2.9 5.9 6.5.95-4.7 4.6 1.1 6.5L12 17.7l-5.8 3.05 1.1-6.5-4.7-4.6 6.5-.95z" />
      </svg>
    </button>
  );
}
